var map = {
	"./templateLoader": 8,
	"./templateLoader.js": 8,
	"./templateLoaderIndirect": 9,
	"./templateLoaderIndirect.js": 9,
	"./tmpl": 10,
	"./tmpl.js": 10
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4;



/*****************
 ** WEBPACK FOOTER
 ** ./parsing/context/templates ^\.\/t.*$
 ** module id = 4
 ** module chunks = 0
 **/